import { useQuery } from '@tanstack/react-query';
import { nswBrandOptions, qldBrandOptions } from '../pages/FormData';

export const fetchBrandsAPI = () =>
    useQuery({
        queryKey: ['brands'],
        queryFn: async () => {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/brands`);
            if (!response.ok) {
                throw new Error('Error making API call');
            }
            const data = await response.json();
            const formattedData = {
                nswBrandOptions: data.nsw.map(brand => ({
                    value: brand.value,
                    label: brand.value,
                    eway_group: brand.eway_group
                })),
                qldBrandOptions: data.qld.map(brand => ({
                    value: brand.value,
                    label: brand.value,
                    eway_group: brand.eway_group
                }))
            }
            return formattedData; 
        },
        initialData: {
            nswBrandOptions,
            qldBrandOptions
        }
    });